import { useMutation } from '@tanstack/react-query';

import { agent } from 'api/agent';

interface Props {
  isTwoFAEnabled: boolean;
}

const enableTwoFaMutation = () => useMutation({
  mutationKey: ['isTwoFAEnabled'],
  mutationFn: (body: Props) => agent.getClient().patch('/twofa', body),
});

export default enableTwoFaMutation;
